import axios from "axios";
import * as Config from "../../Utils/Config";



export async function getAllFeeProtector(data) {
    try {
        const res = await axios.post(`${Config.base_url}getAllFeeProtector`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}


export async function prepareContractApi(data) {
    try {
        const res = await axios.post(`${Config.base_url}prepareContractApi`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function runComparisonApi(data) {
    try {
        const res = await axios.post(`${Config.base_url}runComparisonApi`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

// get all email logs
export async function getAllEmailLogs(data) {
    try {
        const res = await axios.post(`${Config.base_url}getAllEmailLogs`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}


















